import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, ChangeDetectionStrategy} from "@angular/core";
import { AltSecDropDownComponent } from "./com-alt-securities-dropdown.component";

@Component({ standalone: false,
    selector: 'alt-sec-dropdown-cell',
    templateUrl: './com-alt-securities-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
  })
export class AltSecDropDownCellRenderer extends AltSecDropDownComponent implements ICellRendererAngularComp {

    params: any;

    agInit(params: any): void {
        this.params = params;
        this.populateAltSecurity(params);
        this.populateSecuritiesDropdown(params);
        this.removeRestrictionSymbolFromDropDown();
    }

    refresh(params: any): boolean {
        this.populateAltSecurity(params);
        this.populateSecuritiesDropdown(params);
        this.removeRestrictionSymbolFromDropDown();
        return true;
    }

}
